import { useState } from "react"

import './Dashboard.css';

import { palette } from "../../assets/theme/theme";
import { userIsAdmin } from "../../utils/UserInfoHandler";
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";
import { DespesasChart } from "../../charts/DespesasChart/index";
import { NewGantt } from "../../charts/Gantt";
import { VolumeFaturacaoChart } from "../../charts/NovosIndicadores/VolumeFaturacao";
import { CustosAbsolutosChart } from "../../charts/NovosIndicadores/CustosAbsolutos";
import { NCCChart } from "../../charts/NovosIndicadores/NCC";
import { VMHRChart } from "../../charts/NovosIndicadores/VMHR";
import { RentabilidadeFerramentasChart } from "../../charts/NovosIndicadores/RentabilidadeFerramentas";
import { IndiceSatisfacaoClientesChart } from "../../charts/NovosIndicadores/IndiceSatisfacaoCliente";
import { TEOChart } from "../../charts/NovosIndicadores/TEO";
import { ParetoCustosChart } from "../../charts/NovosIndicadores/ParetoCustos";
import { HistoricoFaturacaoChart } from "../../charts/HistoricoFaturacao";



export default function Dashboard() {

  const [gridView, setGridView] = useState(false);



  return (
    <div className="max-w-auto overflow-hidden">
      <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
        <CustomTitle text={'Dashboard'} />
        <div style={{ margin: 30, cursor: 'pointer', padding: 10 }}>
          {gridView ? <ViewListIcon style={{ fontSize: '2em', color: palette.rodrimaq_red }} onClick={() => setGridView(false)} /> : <GridViewIcon style={{ fontSize: '2em', color: palette.rodrimaq_red }} onClick={() => setGridView(true)} />}

        </div>
      </div>
      <div >
        <div className="w-full p-3">
          <HistoricoFaturacaoChart />
        </div>
        {userIsAdmin() ?
          <>
            {/* <div className="grid grid-cols-2 gap-4 p-4">
              <div className="col-span-1">
                <VolumeFaturacaoChart />
              </div>
              <div className="col-span-1">
                <CustosAbsolutosChart />
              </div>
              <div className="col-span-1">
                <NCCChart />
              </div>
              <div className="col-span-1">
                <VMHRChart />
              </div>
              <div className="col-span-1">
                <RentabilidadeFerramentasChart />
              </div>
              <div className="col-span-1">
                <IndiceSatisfacaoClientesChart />
              </div>
              <div className="col-span-1">
                <TEOChart />
              </div>
              <div className="col-span-1">
                <ParetoCustosChart />
              </div>
            </div> */}


            <NewGantt />

            <DespesasChart />

            {/* <div style={{ display: gridView ? 'flex' : 'block' }}>
            <div style={{ maxWidth: gridView ? '50%' : '100%' }}>
              <FaturacaoChart style={cardStyle} />
            </div>
            <div style={{ maxWidth: gridView ? '50%' : '100%' }}>
              <ValorAReceber style={cardStyle} />
            </div>
          </div>

          <div style={{ display: gridView ? 'flex' : 'block' }}>
            <div style={{ maxWidth: gridView ? '50%' : '100%', minWidth: gridView ? '50%' : '100%' }}>

              <ValoresObras style={cardStyle} />
            </div>
            <div style={{ maxWidth: gridView ? '50%' : '100%', minWidth: gridView ? '50%' : '100%' }}>

              <FaturacaoPorCliente style={cardStyle} />
            </div>


          </div> */}
          </> :
          null
          // <div style={cardStyle}>
          //   <GanttGraph />
          // </div>
        }
      </div>

    </div>)

}